import styled from "styled-components";
import { colors } from "constants/colors";

export const StyledMusicBox = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  justify-content: flex-end;
  z-index: 2;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const StyledMusicWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 6px 0 4px;
  border-radius: 800px;
  border: 1px solid ${colors.white};
`;

export const StyledMusicIcon = styled.img`
  width: 24px;
  height: 24px;
`;
